const delay=require('pulsar-utils/dist-es6/async/delay');

async function waitUntil(predicate,delayInMilliseconds=0){
while(!predicate()){
await delay(delayInMilliseconds);
}
}

module.exports=waitUntil;
//# sourceMappingURL=waitUntil.js.map
